document.addEventListener("DOMContentLoaded", function () {
	const weatherWidgets = document.querySelectorAll(".bds-weather");
	weatherWidgets.forEach(function (weatherElem) {
		getWeatherConditions(weatherElem);
	});
});

function fetchWeatherAJAX(lat, lon, weatherElem) {
	$.post(
		bds_theme.ajax_url,
		{
			action: "bds_get_weather",
			lat: lat,
			lon: lon,
		},
		function (response) {
			if (response.success) {
				if (weatherElem) {
					const temperature = response.data.temperature;
					const conditions =
						response.data.conditions.charAt(0).toUpperCase() +
						response.data.conditions.slice(1);

					// Update temperature
					const tempElem = weatherElem.querySelector(".bds-weather-temperature");
					if (tempElem) {
						tempElem.innerHTML = `${temperature}&deg;${weatherElem.dataset.unit || "C"}`;
					}

					// Update conditions
					const condElem = weatherElem.querySelector(".bds-weather-conditions");
					if (condElem) {
						condElem.textContent = conditions;
					}

					// Update icon
					const iconElem = weatherElem.querySelector(".bds-weather-icon");
					if (iconElem) {
						const sanitized = conditions
							.toLowerCase()
							.replace(/\s+/g, "-")
							.replace(/[^a-z0-9\-]/g, "");
						iconElem.className = `bds-weather-icon bds-weather-icon--${sanitized}`;
					}

					// Update location
					const locElem = weatherElem.querySelector(".bds-weather-location");
					if (locElem) {
						if (response.data.city) {
							locElem.textContent = response.data.city;
						} else {
							locElem.textContent = "";
						}
					}
				}
			} else {
				console.error(response.data.message);
			}
		},
	);
}

function getWeatherConditions(weatherElem) {
	const lat = weatherElem.dataset.lat || bds_theme.features.weather.default_coords.lat;
	const lon = weatherElem.dataset.lon || bds_theme.features.weather.default_coords.lon;
	fetchWeatherAJAX(lat, lon, weatherElem);
}
